var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12591_10781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7604 15C10.5867 14.976 10.5018 14.9039 10.8395 13.7321C11.646 10.9358 13.1001 8.65144 15.9899 7.62199C17.1304 7.21539 18.3151 7.02317 19.5386 7.20984C19.939 7.27083 20.0387 7.43347 19.9833 7.83638C19.5349 11.08 16.4328 14.2422 13.0835 14.8355C12.6461 14.9131 12.1996 14.9464 11.7585 15.0019L11.7604 15Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24873 14.9686C4.39563 14.9095 0.61264 11.6104 0.0147438 7.79944C-0.046153 7.41502 0.0867128 7.20617 0.439176 7.20802C1.19208 7.21356 1.95791 7.19139 2.6942 7.31522C5.99371 7.86968 7.81323 10.0838 8.94628 13.0299C9.09206 13.4087 9.18987 13.8079 9.27475 14.2053C9.41316 14.8577 9.32458 14.9557 8.6584 14.9686C8.52185 14.9705 8.38529 14.9686 8.25058 14.9686H8.24873Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30998 11.298C8.66226 10.4349 8.08097 9.58658 7.42587 8.80109C6.49027 7.67554 5.23912 7.00834 3.85879 6.59434C3.48602 6.48345 3.25536 6.30602 3.21107 5.95301C3.09296 5.03446 2.98409 4.1122 2.92873 3.1881C2.89736 2.67615 3.16678 2.48764 3.71485 2.61331C6.71356 3.30454 8.39283 5.31723 9.17158 8.15422C9.41147 9.03212 9.36165 9.99133 9.42808 10.9136C9.43731 11.0374 9.35427 11.1668 9.31367 11.2962L9.30998 11.298Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6643 11.4588C10.321 9.79729 10.6034 8.36494 11.192 6.99727C12.1701 4.72398 13.7792 3.14562 16.2797 2.62997C16.9163 2.49875 17.0437 2.59485 17.1064 3.23433C17.2042 4.2416 17.0474 5.21375 16.6801 6.14894C16.6211 6.30234 16.4513 6.47977 16.3 6.51858C13.7479 7.18209 12.0667 8.86395 10.8636 11.1188C10.8285 11.1853 10.7879 11.2481 10.6643 11.457V11.4588Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97433 7.01577C9.33399 6.02513 8.6143 4.9273 7.91491 3.81653C7.82449 3.67237 7.76912 3.4432 7.81341 3.2861C8.17695 1.98312 8.84681 0.872351 9.93373 0C11.1517 0.800271 11.7883 1.97018 12.1961 3.29349C12.2349 3.41732 12.1888 3.60769 12.1131 3.72228C11.3842 4.86077 10.6405 5.99187 9.97248 7.01577H9.97433Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12591_10781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/Wellness.aea47bcc0518eb9ae294781987503df7.svg";
export { ForwardRef as ReactComponent };